import React from 'react';

import { lensTokens } from '~/configs/unifiedAnalyticsTheme';

import PushPinIcon from '@mui/icons-material/PushPin';
import { Box, ButtonBase, IconButton, Tooltip, Typography, useTheme } from '@mui/material';

export default function RailPinnedItem({
  label,
  icon,
  active,
  onOpen,
  onUnpin,
  handle,
  tag,
}: {
  label: string;
  icon: React.ReactNode;
  active: boolean;
  onOpen: () => void;
  onUnpin?: () => void;
  handle?: React.ReactNode;
  tag?: string;
}) {
  const tokens = lensTokens(useTheme());
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 32,
        borderRadius: '8px',
        bgcolor: active ? tokens.railActive : undefined,
        '&:hover': { bgcolor: tokens.railHover },
        '&:hover .pin-control, &:focus-within .pin-control': { opacity: 1 },
      }}
    >
      <ButtonBase
        aria-current={active ? 'page' : undefined}
        onClick={onOpen}
        sx={{
          minWidth: 0,
          flex: '0 1 auto',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: 0.75,
          pl: 1.25,
          py: 0.5,
          color: tokens.railText,
          textAlign: 'left',
          fontSize: 13,
          fontWeight: active ? 600 : 400,
        }}
      >
        <Box component="span" sx={{ width: 18, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
          {icon}
        </Box>
        <Box component="span" sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          {label}
        </Box>
      </ButtonBase>
      {onUnpin && (
        <Tooltip title="Unpin">
          <IconButton
            aria-label={`Unpin ${label}`}
            onClick={onUnpin}
            size="small"
            className="pin-control"
            sx={{ color: tokens.railText, opacity: 0.55, ml: 0.25, p: 0.375 }}
          >
            <PushPinIcon sx={{ fontSize: 12 }} />
          </IconButton>
        </Tooltip>
      )}
      {tag && (
        <Typography component="span" sx={{ fontSize: 10, color: tokens.railTextMuted, ml: 0.75, flexShrink: 0 }}>
          {tag}
        </Typography>
      )}
      <Box sx={{ flex: 1 }} />
      {handle && (
        <Box className="pin-control" sx={{ color: tokens.railText, opacity: 0 }}>
          {handle}
        </Box>
      )}
    </Box>
  );
}
